module.exports = __webpack_public_path__ + "img/662.60e7d065.png";